/* Event photos slideshow — arrows, thumbnail strip, keyboard nav. */
(function () {
  'use strict';

  function init(gallery) {
    if (gallery.dataset.inited === '1') return;
    gallery.dataset.inited = '1';

    var slides = Array.prototype.slice.call(gallery.querySelectorAll('.event-gallery__slide'));
    var thumbs = Array.prototype.slice.call(gallery.querySelectorAll('.event-gallery__thumb'));
    var prev = gallery.querySelector('.event-gallery__nav--prev');
    var next = gallery.querySelector('.event-gallery__nav--next');
    var current = gallery.querySelector('.event-gallery__current');

    if (slides.length <= 1) return;

    var index = 0;

    function show(i) {
      index = (i + slides.length) % slides.length;

      slides.forEach(function (s, n) {
        s.classList.toggle('is-active', n === index);
      });
      thumbs.forEach(function (t, n) {
        var active = n === index;
        t.classList.toggle('is-active', active);
        if (active) {
          t.setAttribute('aria-current', 'true');
          // Keep the active thumbnail in view within the strip.
          t.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'nearest' });
        } else {
          t.removeAttribute('aria-current');
        }
      });
      if (current) current.textContent = String(index + 1);
    }

    if (prev) prev.addEventListener('click', function () { show(index - 1); });
    if (next) next.addEventListener('click', function () { show(index + 1); });

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        var i = parseInt(t.getAttribute('data-index'), 10);
        if (!isNaN(i)) show(i);
      });
    });

    // Keyboard arrows when the gallery (or something inside it) has focus.
    gallery.setAttribute('tabindex', gallery.getAttribute('tabindex') || '0');
    gallery.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowLeft') { e.preventDefault(); show(index - 1); }
      else if (e.key === 'ArrowRight') { e.preventDefault(); show(index + 1); }
    });

    // Touch / swipe on the stage.
    var stage = gallery.querySelector('.event-gallery__stage');
    if (stage) {
      var startX = 0;
      stage.addEventListener('touchstart', function (e) {
        startX = e.changedTouches[0].screenX;
      }, { passive: true });
      stage.addEventListener('touchend', function (e) {
        var diff = startX - e.changedTouches[0].screenX;
        if (Math.abs(diff) > 50) show(index + (diff > 0 ? 1 : -1));
      }, { passive: true });
    }
  }

  function initAll(root) {
    (root || document).querySelectorAll('event-photos.event-gallery').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initAll(); });
  } else {
    initAll();
  }

  // Theme editor re-init.
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
